import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './InfoGatheringDialog.module.css'

export interface InfoGatheringDialogScrollAreaProps {
  children: ReactNode
}

export function InfoGatheringDialogScrollArea({
  children,
}: InfoGatheringDialogScrollAreaProps) {
  return (
    <div className={styles.scrollArea}>
      <div className={styles.scrollAreaInner}>{children}</div>
    </div>
  )
}

export interface InfoGatheringDialogSubsectionHeaderProps {
  bordered?: boolean
  children: ReactNode
}

export function InfoGatheringDialogSubsectionHeader({
  bordered,
  children,
}: InfoGatheringDialogSubsectionHeaderProps) {
  return (
    <div
      className={cx(
        styles.subsectionHeader,
        bordered && styles.subsectionHeaderBordered,
      )}
    >
      {children}
    </div>
  )
}

export interface InfoGatheringDialogFieldGridProps {
  children: ReactNode
}

export function InfoGatheringDialogFieldGrid({
  children,
}: InfoGatheringDialogFieldGridProps) {
  return <div className={styles.fieldGrid}>{children}</div>
}
